export default __webpack_public_path__ + "ba4bb7fd9fb7c8031d8ae1dd9b096626.png";